import ndjsonStream from 'can-ndjson-stream'

export default {
  methods: {
    streamJson: (path = '', handle = () => { }, onDone = () => { }) => {
      fetch(`${process.env.api_url}${path}`, {
        ...this.config,
        method: 'GET'
      })
        .then((response) => {
          return ndjsonStream(response.body)
        })
        .then((docStream) => {
          let read
          const reader = docStream.getReader()
          reader.read().then(
            (read = ({ value, done }) => {
              if (done) return onDone()
              handle(value)
              reader.read().then(read)
            })
          )
        })

      return true
    }
  }

}



// WEBPACK FOOTER //
// ./src/lib/streamApi.js